var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 7.895,
    height: 10,
    viewBox: "0 0 7.895 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2017",
    "data-name": "Rectangle 2017",
    width: 7.895,
    height: 10,
    transform: "translate(0 0)",
    fill: "#3e3e3e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    "data-name": "Group 3847",
    transform: "translate(0 0.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3803",
    "data-name": "Group 3803",
    transform: "translate(0 -0.114)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8712",
    "data-name": "Path 8712",
    d: "M7.8,6.442a.337.337,0,0,0,.1-.239V1.015a.339.339,0,0,0-.489-.3L7.4.715,7.374.727,7.268.773c-.094.038-.232.091-.4.144a4.629,4.629,0,0,1-1.339.21A3.827,3.827,0,0,1,4.2.827L4.145.809A5.008,5.008,0,0,0,.677.716V.338A.338.338,0,0,0,0,.338V9.361a.338.338,0,0,0,.677,0V6.867a3.931,3.931,0,0,1,1.692-.325,4.626,4.626,0,0,1,1.472.321l.02.007a5.19,5.19,0,0,0,1.666.349A3.719,3.719,0,0,0,7.2,6.844a2.8,2.8,0,0,0,.433-.265c.05-.037.088-.069.115-.092l.032-.029.01-.01,0,0h0",
    transform: "translate(0 0.053)",
    fill: "#3e3e3e",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.1c363b2a68029e47029cb3b4a685bf3e.svg";
export { ForwardRef as ReactComponent };